module.exports = __webpack_public_path__ + "img/conversao_cliente.fadc03ca.jpg";